export enum UploadStatusEnum {
  UNKNOWN = "unknown",
  PENDING_MATCHING = "pending_matching",
  PENDING_COLUMNS = "pending_columns",
  STARTED_MATCHING = "started_matching",
  STARTED_COLUMNS = "started_columns",
  PENDING = "pending",
  PROCESSED = "processed",
  PER_OCCURRENCE_LIMIT = "per_occurrence_limit",
}
